import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_details1_edit = () => {
  useAuthRedirect();
  const [detail, setDetail] = useState([]);
  const [data, setData] = useState([]);
  const [editedHr, setEditedHr] = useState({});
  const { vcode, sno, branch } = useParams();
  const [loading, setLoading] = useState(false);

        const canEdit  = hasPermission("Periodic Entry (Own Vehicle)", "edit");
  

  const navigate = useNavigate();

  // Fetch Vehicle Details
  useEffect(() => {
    if (branch && vcode) {
      axios
        .get(`https://rfs2.infraconsoft.net.in/api/vehicle_maintenance_edit_intro?branch_code=${branch}&vehicle_code=${vcode}`)
        .then((response) => {
          setDetail(response.data.vehicles);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        });
    }
  }, [branch, vcode]);

  useEffect(() => {
  if (branch && vcode && sno) {
    setLoading(true); // Start loading
    axios
      .get(`https://rfs2.infraconsoft.net.in/api/vehicle_maintenance_edit_table?branch_code=${branch}&vehicle_code=${vcode}&sno=${sno}`)
      .then((response) => {
        setData(response.data.vehicles);

        const initialEditedHr = {};
        response.data.vehicles.forEach((row) => {
          initialEditedHr[row.SlNo] = row.last_modified_hr || "";
        });
        setEditedHr(initialEditedHr);
        setLoading(false); // End loading
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
        setLoading(false); // End loading even if error
      });
  }
}, [branch, vcode, sno]);

  // Handle Input Change
  const handleInputChange = (SlNo, value) => {
    setEditedHr((prev) => ({
      ...prev,
      [SlNo]: value,
    }));
  };

  const nonNegativeNumber2dp = /^\d+(\.\d{1,2})?$/;

  const handleUpdate = (SlNo) => {

      const raw = (editedHr?.[SlNo] ?? "").toString().trim();

      if (raw === "") {
     Swal.fire({
      icon: "warning",
      title: "Missing value",
      text: "Please enter Last Changed Hr/Km.",
      width: "420px",
    });
    return;
  }

  // 2) numeric & non-negative check (0 allowed)
  if (!nonNegativeNumber2dp.test(raw)) {
     Swal.fire({
      icon: "warning",
      title: "Invalid Hr/Km",
      text: "Only non-negative numbers are allowed (e.g., 0, 12, 12.5, 12.34). No letters or minus sign.",
      width: "460px",
    });
    return;
  }

   const value = Number(raw);

    Swal.fire({
              title: "Submitting...",
              text: "Please wait while we process your request.",
              allowOutsideClick: false,
              didOpen: () => {
                  Swal.showLoading();
              },
          });
    axios
      .post("https://rfs2.infraconsoft.net.in/api/update_vehicle", {
        sno: SlNo,
        txtchkm: value,
      })
      .then((response) => {
        Swal.fire({
          title: "Success!",
          text: "Vehicle maintenance Last Changed Hr/Km updated successfully.",
          icon: "success",
          width: "500px",
          height : "40vh",
          draggable: true,
        }).then(() => {
          navigate(-1);
        });

        // Refresh data after update
        axios
          .get(`https://rfs2.infraconsoft.net.in/api/vehicle_maintenance_edit_table?branch_code=${branch}&vehicle_code=${vcode}&sno=${sno}`)
          .then((response) => {
            setData(response.data.vehicles);
          })
          .catch((error) => {
            console.error("Error refreshing data:", error);
          });
      })
      .catch((error) => {
        console.error("Error updating vehicle:", error);
        Swal.fire({
          title: "Error!",
          text: "Update failed! Please try again.",
          icon: "error",
          draggable: true,
        });
      });
  };

  if (!canEdit) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
          <div className="back-div">
          <h2 className="add-txt">Vehicle Maintenance - Edit</h2>
           <p 
      className="back-button" 
      style={{ cursor: "pointer" }} 
      onClick={() => navigate(-1)}
    >
      <i className="fa-solid fa-backward"></i> Back
    </p>
          </div>

          <div>
            <Time />
          </div>
        </section>

        {Array.isArray(detail) &&
          detail.map((item, index) => (
            <div key={index}>
              <p>Vehicle Code: {item.vehicle_code}</p>
              <p>Vehicle Type: {item.vehicle_type}</p>
              <p>Vehicle Name: {item.vehicle_name}</p>
            </div>
          ))}

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Description</th>
                <th>Oil Grade</th>
                <th>Last Changed Hr/Km</th>
                <th>Service Hr/Km</th>
                <th>Next Service Hr/Km</th>
                <th>Current Cum Hr/Km</th>
                <th>Remaining Hr</th>
              </tr>
            </thead>
           <tbody>
  {loading ? (
    <tr>
      <td colSpan="9" className="text-center">Loading... Please wait</td>
    </tr>
  ) : data.length > 0 ? (
    data.map((row, index) => {
      const service_km = parseInt(row.last_modified_hr || 0) + parseInt(row.changing_hrs || 0);
      const service_value =
        row.vehicle_basis === "Hour"
          ? parseInt(row.cumulative || 0) + parseInt(row.fld_wohrs || 0)
          : parseInt(row.cumulative || 0) + parseInt(row.fld_wokm || 0);
      const remainingHr = service_km - service_value;

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{row.fld_Descriptions}</td>
          <td>{row.oilgrade}</td>
          <td>
            <input
              name="lastHr"
              type="number"
              value={editedHr[row.SlNo] || ""}
              onChange={(e) => handleInputChange(row.SlNo, e.target.value)}
            />
          </td>
          <td>{row.changing_hrs}</td>
          <td>{service_km}</td>
          <td>{service_value}</td>
          <td>{remainingHr}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>
        <div className="btn-cls">
            <button onClick={() => handleUpdate(sno)} className="submit-btn">Update</button>
            </div>
      </div>
    </div>
  );
};

export default Vehicle_details1_edit;
